// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ISO 19115-1 Role codes for responsible parties
 * @export
 */
export const RoleCode = {
  ResourceProvider: "resourceProvider",
  Custodian: "custodian",
  Owner: "owner",
  User: "user",
  Distributor: "distributor",
  Originator: "originator",
  PointOfContact: "pointOfContact",
  PrincipalInvestigator: "principalInvestigator",
  Processor: "processor",
  Publisher: "publisher",
  Author: "author",
} as const;
export type RoleCode = (typeof RoleCode)[keyof typeof RoleCode];

export function instanceOfRoleCode(value: any): boolean {
  for (const key in RoleCode) {
    if (Object.prototype.hasOwnProperty.call(RoleCode, key)) {
      if (RoleCode[key as keyof typeof RoleCode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RoleCodeFromJSON(json: any): RoleCode {
  return RoleCodeFromJSONTyped(json, false);
}

export function RoleCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleCode {
  return json as RoleCode;
}

export function RoleCodeToJSON(value?: RoleCode | null): any {
  return value as any;
}

export function RoleCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): RoleCode {
  return value as RoleCode;
}
